export default class BillPayment {
  static all(workbench) {
    return workbench.getReqData(
      '/bill_payments.json'
    ).then((json) => {
      return {
        payments: {
          unacknowledged: json.unacknowledged.map((payment) => new BillPayment(payment.user, payment.payment, payment.comment, new Date(payment.date), payment.slug)),
          acknowledged: json.acknowledged.map((payment) => new BillPayment(payment.user, payment.payment, payment.comment, new Date(payment.date), payment.slug, new Date(payment.acknowledged_at), payment.acknowledged_by))
        }
      }
    })
  }

  static async create(workbench, user, payment, comment) {
    const params = {
      user: {
        name: user.name,
        company: user.company,
        email: user.email,
        phone: user.phone,
      },
      payment: {
        amount_cents: payment.amountCents,
        account: payment.account,
        invoice: payment.invoice,
        payment_token: payment.paymentToken,
      },
      comment: comment
    }

    return await workbench.postReq(
      '/billpay',
      params
    )
  }

  static ack(workbench, paymentSlug, payments) {
    return workbench.postReq(
      `/bill_payments/${paymentSlug}/ack`
    ).then((resp) => {
      if (resp.ok) {
        for (const [index, payment] of payments.unacknowledged.entries()) {
          if (payment.slug === paymentSlug) {
            payment.setAckAttrs(new Date())
            payments.unacknowledged.splice(index, 1)
            payments.acknowledged.unshift(payment)
            break
          }
        }
        return {
          success: true,
          payments: payments
        }
      } else {
        return resp.json().then((json) => {
          return {
            success: false,
            errors: BillPayment.errorsStr(json.errors)
          }
        })
      }
    })
  }

  static errorsStr(errorsHash) {
    const errors = []
    for (var field in errorsHash) {
      errors.push(`${errorsHash[field]}`)
    }
    return errors.join(', ')
  }

  constructor(user, payment, comment, date = undefined, slug = "", acknowledgedOn = undefined, acknowledgedBy = undefined) {
    this.user = user
    this.payment = payment
    this.comment = comment
    this.date = date
    this.slug = slug
    this.acknowledgedOn = acknowledgedOn
    this.acknowledgedBy = acknowledgedBy
  }

  setAckAttrs(date) {
    this.acknowledgedBy = "You"
    if (date) {
      this.acknowledgedOn = date
    }
  }

  get name() {
    if (this.user.company && this.user.name) {
      return `${this.user.company} (${this.user.name})`
    }

    return this.user.name || this.user.company
  }

  get user_name() { return this.user.name }
  get user_email() { return this.user.email }
  get user_phone() { return this.user.phone }
  get invoice() { return this.payment.invoice }
  get account() { return this.payment.account }
  get amountCents() { return this.payment.amountCents || this.payment.amount_cents }
  get acknowledged() { return this.acknowledgedOn !== undefined }
}
